import {Button, Card, Col, Row} from "reactstrap";
import {API_URL, APP_URL, ORGANIZATION_PATHS} from "../../config";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import React, {useState, useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import LogoLRF from "../../AppSystem/assets/img/LRF-new-logo.png";
import useApiCallService from "../../Common/Helpers/ApiCall";
import ResponseQRCode from "../Models/Response/ResponseQRCode";
import {CustomReload} from "../../AppSystem/Helpers/CustomReload";
import {CheckUserPermission} from "../../AppSystem/Helpers/CheckUserPermission";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import {generateFileName} from "../../AppSystem/Helpers/GenerateFileName";
import SortableList from "../../Common/Components/Lists/SortableList";
import ResponseQRPayment from "../Models/Response/ResponseQRPayment";
import $ from "jquery";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";

export function QRCodeInfo() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { ApiCall } = useApiCallService();
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') ?? "";
    const [infoQR, setInfoQR] = useState(new ResponseQRCode());
    const [inactiveQR, setInactiveQR] = useState({});
    const [isDownloading, setIsDownloading] = useState(false);
    const isMobile = CheckMobile(998);
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('QRCode.label'));
        setPageTitleKey('QRCode.label');
        setOnBack(() => navigate(ORGANIZATION_PATHS.QR_CODE_LIST));
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    let permissionUpdate = false;
    if (CheckUserPermission("org.collect.qr-pay.update") || CheckUserPermission("org.collect.qr-pay") || CheckUserPermission("org.collect") || CheckUserPermission("org")) {
        permissionUpdate = true;
    }
    let permissionCreate = false;
    if (CheckUserPermission("org.collect.qr-pay.create") || CheckUserPermission("org.collect.qr-pay") || CheckUserPermission("org.collect") || CheckUserPermission("org")) {
        permissionCreate = true;
    }


    // GET QR
    useEffect(() => {
        if (id !== "") {
            const handleApiResponseQR = (apiResponse) => {
                setInfoQR(new ResponseQRCode(apiResponse));
            };
            const fetchData = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/orgqr?id=${id}`
                    };
                    await ApiCall(apiCallOptions, handleApiResponseQR);
                } catch (error) {
                    console.log('error', error);
                }
            };
            fetchData();
            setInactiveQR(()=>({
                id: id,
            }));
        }
    }, []);


    const [activateCollection, setActivateCollection] = useState(null);

    useEffect(() => {
        if (activateCollection !== null) {
            CustomReload()
        }
    }, [activateCollection]);


    const handleInactiveQR = async () => {
        if (infoQR.status === 'Aktiv') {
            inactiveQR.status = 'Inaktiv'
        } else {
            inactiveQR.status = 'Aktiv'
        }
        const apiCallOptions = {
            method: "put",
            url: '/orgqr',
            data: inactiveQR
        };
        try {
            await ApiCall(apiCallOptions, setActivateCollection);
            $("#disableCollection").prop("disabled", true);
            $("#downloadQR").removeClass("btn-submit-kassan");
            $("#downloadQR").addClass("disabled-imitation");
            $("#editQR").prop("disabled", true);
            //$("#editQR").addClass("disabled");
        } catch (error) {
            console.log(error);
        }
    }

const downloadFile = async (url, number) => {
            const handleDownloadApiResponse  = (response) => {
                let file;
                if (response instanceof Blob) {
                    file = response;
                } else {
                    file = new Blob([response]);
                }
                const newFileName = generateFileName('Kvitto', number);
                let fileName = newFileName;
                const urlToFile = URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = urlToFile;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
    
            const apiCallOptions = {
                method: "get",
                url: url,
                dataTypes: 'blob',
                responseType: 'blob'
            };
            try {
                await ApiCall(apiCallOptions, (response) => handleDownloadApiResponse(response));
            } catch (error) {
                console.log(error);
            }
        }

    const renderActionColumn = (item) => {
            return (
                <>              
                {item.receiptFileUrl ?
                    <div style={{ display: 'flex', gap: '10px' }}>
                            <CustomButton icon="bx bx-download py-1" iconColor="#157553" hoverIconColor='white' hoverButtonColor='#A3C2B8' iconSize={4} buttonColor="#cde0da" tooltipText={t('button.info')} customClasses="rounded border-0" buttonBorder={false} onClick={() => {downloadFile(item.receiptFileUrl ,item.id)  }}  />
                    </div>
                : ''} 
                </>
            );
        }

    const columns = [ {
                        "field" : "visualId",
                        'label': t('modelLabel.id'),
                        'sortable': true,
                        'sortField': 'visualId',
                        'value': (item) => infoQR.visualId + "-" +item.visualId || "",
                    }, 'provider', 'method', 'comment', 'createdAt', 'updatedAt', 'amount'];
    const listOptions = {
        "model": ResponseQRPayment,
        'columns': columns,
        "actions": {
            "actionColumn" : renderActionColumn,
        },
        "exportIsAvailable": true,
        "urlGetListItemsToExport": (id !== "" ? "/orgqr/payment/search/filter?orgQrId=" + id : "/orgqr/payment/search/filter"),
        "nameFile": t('QRCode.orgQRLabel'),
        "ignoreFields" : columns,
        "filterTestIsAvailable": true,
        "urlGetSearch" : (id !== "" ? "/orgqr/payment/search/filter?orgQrId=" + id : "/orgqr/payment/search/filter"),
        "ignoreUrlParams": true,
    };

    const  handleDownload = (e) =>{
        if (isDownloading) {
            // Prevenir clics adicionales si está descargando
            e.preventDefault();
            return;
        }
        setIsDownloading(true);

        // Simulamos que la descarga tomará 2 segundos
        setTimeout(() => {
            setIsDownloading(false);
        }, 2000);
    }

    const renderInfoContent = (html) => {
        if (!html) return "";
        let result = html.replace(
            /<img /g,
            '<img style="max-width:100%;height:auto;display:block;margin:0.5rem auto;" '
        );
        result = result.replace(
            /<iframe /g,
            '<iframe referrerpolicy="strict-origin-when-cross-origin" style="width:100%;aspect-ratio:16/9;display:block;margin:0.5rem auto;" '
        );
        result = result.replace(
            /<video /g,
            '<video style="width:100%;height:auto;display:block;margin:0.5rem auto;" controls '
        );
        return result;
    };

    return (
        <>
            {!isMobile && (
                <Col lg={12} className="px-0">
                    <CustomButton
                        text={t('button.back')}
                        icon={'bx bx-chevron-left'}
                        buttonSize={'small'}
                        customClasses={'mb-3 ms-3 backButton'}
                        onClick={() => {
                            navigate(ORGANIZATION_PATHS.QR_CODE_LIST)
                        }}
                    />
                </Col>
            )}
            {infoQR.id !== '' ?
                <>
                    <Col lg={12} className="mb-3 mx-0 px-0">
                        <Card className="card-backend p-4">
                            <Row>
                                <h2 className='rokkitt-font'>{t('QRCode.label')}</h2>
                                <Col xl={12} className="text-center">
                                    <img src={LogoLRF} alt={t('accessibility.logo')} className='img-fluid' style={{ maxWidth: '120px' }}/>
                                    <Row>
                                        <Col xl={10} className="mx-auto">
                                            <div className="px-3 pt-4 pb-3 text-center qr-info-content"
                                                dangerouslySetInnerHTML={{ __html: renderInfoContent(infoQR.info) }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="pb-3">
                                        <Col lg={3} className="mx-auto">
                                           <img src={API_URL + infoQR.fileUrl} className="img-fluid"/>
                                        </Col>
                                        <Link to={'/qr-code-payment?id='+infoQR.id } target="_blank" className="text-info" >{APP_URL+'/qr-code-payment?id='+infoQR.id }</Link>
                                    </Row>
                                    <Row>
                                        <Col lg={12} className="text-center">
                                            <a id="downloadQR" href={API_URL + infoQR.filePDFUrl} download={generateFileName('orgQR', infoQR.filePDFId)} onClick={handleDownload} className={`btn ${isDownloading ? "bg-grey-tab text-secondary" : "btn-submit-kassan text-white"} mt-3 me-2`}> {isDownloading ? t('modelLabel.downloading') : t('modelLabel.download')}</a>
                                            {permissionCreate === true ?
                                                <Button id="editQR" className=" mt-3 btn-submit-kassan border-0 rounded"
                                                        onClick={() => {
                                                            navigate(`${ORGANIZATION_PATHS.QR_CODE_CREATE}?id=${infoQR.id}`)
                                                        }}>{t('button.edit')}</Button>
                                            : ''}
                                        </Col>
                                        {permissionUpdate === true ?
                                            <Col lg={6} className="mx-auto">
                                                <Button id="disableCollection" className={`w-100 mt-3 ${infoQR.status === 'Aktiv' ? 'box-red' : 'btn-submit-kassan'}  border-0 rounded`} onClick={() =>{
                                                    handleInactiveQR()
                                                }}> {infoQR.status === 'Aktiv' ? t('QRCode.disable') : t('QRCode.enable')}</Button>
                                            </Col>
                                        : ''}
                                    </Row>
                                    <h5 className="rokkitt-font pt-4 pb-3">{t('QRCode.totalCollected')}: {ToCustomDecimal(infoQR.totalPaid)} kr </h5>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col lg={12} className="mb-5 px-0 mx-0">
                        <div className="p-4 card-backend">
                            <h2 className="fw-bold rokkitt-font">{t('QRCode.paymentsReceived')}</h2>
                            <SortableList listOptions={listOptions} />
                        </div>
                    </Col>
                </>
            : ''}
        </>
    );
}